import { Truck } from "lucide-react";

const LOGOS = ["DRY VAN", "REEFER", "FLATBED", "STEP DECK", "POWER ONLY", "HOTSHOT", "CONESTOGA", "DOUBLE DROP"];

export default function LogoMarquee() {
  return (
    <section className="bg-white border-y border-black/10 py-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center gap-10">
        <p className="font-mono-label text-[10px] text-black/50 hidden md:block whitespace-nowrap">
          <span className="inline-block w-4 h-px bg-black/50 mr-2 align-middle"/>WE DISPATCH EVERY TRUCK TYPE
        </p>
        <div className="flex-1 overflow-hidden relative">
          <div className="marquee-track flex items-center gap-16 whitespace-nowrap">
            {[...LOGOS, ...LOGOS].map((l, i) => (
              <div key={i} className="flex items-center gap-3 text-black/70">
                <Truck size={16} strokeWidth={1.5}/>
                <span className="font-display font-semibold tracking-wider text-base">{l}</span>
                <span className="text-black/20">·</span>
              </div>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
        </div>
      </div>
    </section>
  );
}
